import Vue from 'vue';
import { gsap } from 'gsap/all';
import { SplitText } from '../gsap-bonus/SplitText';

gsap.registerPlugin(SplitText);

Vue.component('page-title-component', {
    data() {
        return {
            title: null,
        };
    },

    mounted() {
        this.reveal();
    },

    methods: {
        reveal() {
            this.title = new SplitText(this.$refs.title, {
                type: 'lines',
                linesClass: 'split-line',
            });

            gsap.from(this.title.lines, {
                yPercent: 100,
                stagger: 0.2,
            });
        },
    },
});
